module.exports = {
    QUAL_REVIEWS_MOBILE_WEB: '3069',
    QUAL_REVIEWS_WORK_SAMPLE_MOBILE: '3255',
    QUALAS_REVIEWS_SBSS_INDICATION_3: '3333',
    QUAL_REVIEWS_PRICE_RANGES: '3465',
    QUAL_REVIEWS_BUYER_EXPERIENCE: '3808',
    CARIBOU_RELIABLE_REVIEWS: '4554',
};
